import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IVisibilityLevel } from "../../documentTypes/model/VisibilityLevel";
import VisibilityLevelMapper from "../../documentTypes/service/VisibilityLevelMapper";
import VisibilityLevelParamMapper from "../../documentTypes/service/VisibilityLevelParamMapper";

export default class GetDocumentTypeVisibilityLevelInteractor {
  private resource: GetAllResourceEntriesInteractor<IVisibilityLevel>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(path: string) {
    return this.resource.execute(
      path,
      VisibilityLevelMapper,
      VisibilityLevelParamMapper
    );
  }
}
